/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Start_ListeningInputs */

const en_auth_start_listening = /** @type {(inputs: Auth_Start_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start listening today!`)
};

const es_auth_start_listening = /** @type {(inputs: Auth_Start_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Empieza a escuchar hoy!`)
};

/**
* | output |
* | --- |
* | "Start listening today!" |
*
* @param {Auth_Start_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_start_listening = /** @type {((inputs?: Auth_Start_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Start_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_start_listening(inputs)
	return en_auth_start_listening(inputs)
});